import type {Components, Theme} from '@mui/material/styles';

export const inputOverrides: Components<Theme>['MuiInput'] = {
    defaultProps: {
        disableUnderline: true,
    },
};
